<template>
  <div class="content-3" v-if="info.healthyList && info.healthyList.length">
    <div class="title-content">
      <div class="title">潜在风险</div>
      <div class="tips"
        >你存在<span class="pink">{{ info.healthyList.length }}种</span
        >风险</div
      >
    </div>
    <div class="container">
      <div class="danger-nav">
        <div
          class="danger-nav-item"
          :class="{ 'danger-nav-item-active': curSelect == index }"
          v-for="(item, index) in info.healthyList"
          :key="index"
          @click="bindClick(index)"
        >
          <img
            class="d-nav-icon"
            :src="curSelect == index ? item.selected_icon : item.icon"
            alt=""
          />
          <div class="d-nav-name">{{ item.disease_name }}</div>
        </div>
      </div>
      <div class="nav-dot">
        <div
          class="dot-item"
          :class="{ 'dot-item-active': curSelect == index }"
          v-for="(item, index) in info.healthyList"
          :key="index"
        ></div>
      </div>
      <div class="d-title">{{ info.healthyList[curSelect].disease_name }}</div>
      <div class="r-list">
        <div class="r-item" v-if="info.healthyList[curSelect].factor">
          <div class="r-title">可能影响的因素</div>
          <div class="r-text" v-html="info.healthyList[curSelect].factor"></div>
        </div>
        <div class="r-item" v-if="info.healthyList[curSelect].recommend">
          <div class="r-title">营养建议</div>
          <div
            class="r-text"
            v-html="info.healthyList[curSelect].recommend"
          ></div>
        </div>
        <div class="r-item" v-if="info.healthyList[curSelect].emotion_suggest">
          <div class="r-title">情绪建议</div>
          <div
            class="r-text"
            v-html="info.healthyList[curSelect].emotion_suggest"
          ></div>
        </div>
      </div>
      <div class="b-tips"
        >* 以上仅用于提示潜在健康问题，而非当前身体状况的判断</div
      >
    </div>
  </div>
</template>
<script>
export default {
  props: {
    info: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      curSelect: 0,
      healthyList: [
        {
          disease_id: 1,
          disease_name: '超重肥胖',
          recommend:
            '1、健康减重：肥胖是诱发高血压、糖尿病、痛风、心脏病、癌症等诸多疾病的危险因素，建议通过健康饮食、规律三餐、适量运动来维持正常体重；<br>\n2、均衡营养：排除过敏源的前提下，保证全谷物、蔬菜水果、鱼虾豆制品、奶制品的摄入量，每餐吃到7分饱，一日三餐规律吃饭；（来源：《2022中国居民膳食指南》）<br>\n3、低脂饮食：每日食用油摄入量控制在25克以内，减少油炸物、红油火锅等高油食物的摄入量；<br>\n4、控制热量：减少零食、饮料、宵夜等额外热量摄入，保证正常、规律饮食；<br>\n5、养成运动习惯：可选择饭后散步30分钟，或靠墙站立30分钟，慢慢养成运动习惯。<br>',
          factor:
            '1、饮食能量过剩，热量摄入过高；<br>\n2、运动量少，每日久坐时间过长；<br>\n3、不健康的饮食习惯：进食速度过快、咀嚼次数过少、暴饮暴食、习惯吃夜宵、三餐分配不合理，晚餐过饱、饮水量少、过量吃零食、喝甜饮料等；<br>\n4、饮食摄入营养素不均衡，食物种类不够丰富；<br>\n5、内分泌失衡：甲减、胰岛素抵抗等。<br>',
          icon: 'https:\/\/cdnvue.gymcity.com.cn\/betterwe_1.0\/vue\/cna-res-czfp',
          selected_icon:
            'https:\/\/cdnvue.gymcity.com.cn\/betterwe_1.0\/vue\/cna-res-czfp-se'
        },
        {
          disease_id: 2,
          disease_name: '高血糖',
          recommend:
            '1、维持正常体重：超重肥胖是诱发糖尿病的最大因素，建议通过健康饮食、规律三餐、适量运动来维持正常体重；<br>\n2、低GI饮食：避免过量摄入白米白面等精制主食，可用糙米、燕麦米、红薯、山药等粗粮代替；避免白砂糖、蔗糖等添加糖；<br>\n3、补充营养素：铬元素、硫有助于增强胰岛素；硫辛酸在天然食物中的含量低，建议通过营养补充剂补充；<br>\n4、注意饮食顺序：采用“蔬菜-肉类-主食”的吃饭顺序；<br>\n5、饭前一杯苹果醋：醋酸具有降低餐后血糖的作用，饭前可用15毫升苹果醋兑300毫升水饮用。<br>',
          factor:
            '1、超重肥胖：肥胖人群患2型糖尿病是正常体重人群的12.14倍，体重降低5%~15%，能显著改善血糖；（数据来源：国际权威杂志《柳叶刀糖尿病内分泌》）<br>\n2、遗传：糖尿病亲属中的患病率是非糖尿病亲属的4~8倍；<br>\n3、高能量饮食：2型糖尿病与高脂肪、高蛋白、高碳水化合物和缺乏纤维素的膳食模式有关；<br>\n4、运动量少：每日久坐时间长，没有运动习惯；<br>\n5、有高血压、高血脂等其他疾病。<br>',
          icon: 'https:\/\/cdnvue.gymcity.com.cn\/betterwe_1.0\/vue\/cna-res-gxt',
          selected_icon:
            'https:\/\/cdnvue.gymcity.com.cn\/betterwe_1.0\/vue\/cna-res-gxt-se'
        },
        {
          disease_id: 3,
          disease_name: '高血压',
          recommend:
            '1、维持正常体重：超重肥胖是诱发高血压的最大因素，建议通过健康饮食、规律三餐、适量运动来维持正常体重；<br>\n2、得舒饮食：得舒饮食也被称为DASH饮食，即低钠高钾饮食，是国际公认最适合高血压人群，并且能显著改善血压的饮食方式；<br>\n3、补充营养素：辅酶Q10、黄酮。辅酶Q10建议直接服用营养补充剂，黄酮物质可以通过蜂胶、黄芪、野菊花、金银花获取；<br>\n4、减盐减油：多用清蒸、清炖、水煮的烹饪方式，减少食盐摄入量，每日控制在5克以内；<br>\n5、其他：戒烟限酒，日常监测血压，不可随意减药断药。<br>',
          factor:
            '1、超重肥胖：肥胖人群患高血压的概率是正常体重人群的3.2倍；体重降低5%~15%，能降低收缩压和舒张压（数据来源：国际权威杂志《柳叶刀糖尿病内分泌》）；<br>\n2、高钠多盐饮食：口味重，喜欢咸的、腌制的食物；<br>\n3、能量过剩：进食速度过快、咀嚼次数过少、暴饮暴食、习惯吃夜宵，增加额外热量摄入；<br>\n4、吸烟喝酒；<br>\n5、长期精神紧张：长期精神紧张、劳累、睡眠不足，以及愤怒、烦恼、焦虑、恐惧、抑郁等不良心理也会引发高血压。<br>',
          icon: 'https:\/\/cdnvue.gymcity.com.cn\/betterwe_1.0\/vue\/cna-res-gxy',
          selected_icon:
            'https:\/\/cdnvue.gymcity.com.cn\/betterwe_1.0\/vue\/cna-res-gxy-se'
        },
        {
          disease_id: 4,
          disease_name: '高血脂',
          recommend:
            '1、维持正常体重：超重肥胖是诱发高血脂的最大因素，建议通过健康饮食、规律三餐、适量运动来维持正常体重；<br>\n2、低脂饮食：每日食用油摄入量控制在25克以内，减少油炸物、红油火锅、肥肉、动物脂肪、蛋黄、鱼子、动物内脏及动物骨髓等食物的摄入；<br>\n3、补充营养素：辅酶Q10、植物甾醇、皂苷都能降低胆固醇和调节脂质代谢，但这类物质在天然食物中的含量低，建议通过营养补充剂补充；<br>\n4、多吃新鲜蔬果：蔬菜、水果等天然食物可以提供大量维生素、矿物质、膳食纤维；<br>\n5、戒烟：下定决心戒烟，或通过循序渐进的方式慢慢戒烟。<br>',
          factor:
            '1、超重肥胖：肥胖人群患高血脂的概率是正常体重人群的2倍以上，体重降低5%~15%，能降低甘油三酯、升高HDL-c（数据来源：国际权威杂志《柳叶刀糖尿病内分泌》）；<br>\n2、高脂饮食：高血脂与高脂肪、高蛋白、高碳水化合物和缺乏纤维素的膳食模式有关；<br>\n3、吸烟：香烟中的有害物质容易损伤血管上皮细胞，引发高血脂甚至血栓；<br>\n4、运动量少：每日久坐时间长，没有运动习惯；<br>\n5、有高血压、糖尿病等其他疾病。<br>',
          icon: 'https:\/\/cdnvue.gymcity.com.cn\/betterwe_1.0\/vue\/cna-res-gxz',
          selected_icon:
            '\thttps:\/\/cdnvue.gymcity.com.cn\/betterwe_1.0\/vue\/cna-res-gxz-se'
        },
        {
          disease_id: 9,
          disease_name: '脂肪肝',
          recommend:
            '1、维持正常体重：超重肥胖是诱发脂肪肝的最大因素，建议通过健康饮食、规律三餐、适量运动来维持正常体重；<br>\n2、均衡饮食：保证每天三餐规律，避免高脂肪、高胆固醇、高热量饮食；减少碳水化合物和甜食的摄入，如白砂糖、蜂蜜、果酱等；少吃动物内脏、油炸或油煎食物；<br>\n3、补充营养素：维生素B族能帮助修复肝细胞，预防脂肪肝，推荐糙米、燕麦米、黑米等全谷物；<br>\n4、规律运动：体重降低5%，能显著减轻脂肪肝，建议养成规律的运动习惯；<br>\n5、戒酒：严格限制饮酒量，或直接戒酒。<br>',
          factor:
            '1、超重肥胖：肥胖人群患脂肪肝的概率是正常体重人群的3.5倍（数据来源：《Obesity Reviews》）；<br>\n2、高脂饮食：脂肪肝与高脂肪、高蛋白、高碳水化合物和缺乏纤维素的膳食模式有关；<br>\n3、快速减肥：过度节食、只素不荤会使体重在短期内下降迅速；恢复正常饮食后，身体对油脂的渴望和储存能力变强，引发脂肪肝；<br>\n4、长期酗酒：长期饮酒的人容易患上酒精性脂肪肝；<br>\n5、其他因素：熬夜、肝炎、某些药物引起的急性或慢性肝损害。<br>',
          icon: 'https:\/\/cdnvue.gymcity.com.cn\/betterwe_1.0\/vue\/cna-res-zfg',
          selected_icon:
            'https:\/\/cdnvue.gymcity.com.cn\/betterwe_1.0\/vue\/cna-res-zfg-se'
        }
      ]
    }
  },
  methods: {
    bindClick(index) {
      this.curSelect = index
    }
  }
}
</script>
<style lang="scss" scoped>
.content-3 {
  background: #ffffff;
  border-radius: 12px;
  padding: 20px;
  width: 335px;
  box-sizing: border-box;
  margin: 0 auto 20px;

  .title-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 36px;

    .tips {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: #000000;
      line-height: 20px;

      .pink {
        color: #fd6181;
      }
    }
  }

  .title {
    position: relative;
    z-index: 1;
    display: inline-block;
    font-size: 22px;
    font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.8);
    line-height: 28px;
    height: 28px;
  }

  .title::after {
    position: absolute;
    z-index: -1;
    left: 0;
    bottom: 0;
    content: '';
    width: 100%;
    height: 7px;
    background: linear-gradient(
      270deg,
      rgba(190, 182, 254, 0) 0%,
      #897ffc 100%
    );
    opacity: 0.7;
  }

  .container {
    text-align: center;
  }

  .danger-nav {
    display: flex;
    align-items: center;
    overflow-x: scroll;
    margin-bottom: 19px;

    .danger-nav-item {
      margin-right: 24px;

      .d-nav-icon {
        width: 70px;
        height: 70px;
        object-fit: contain;
        margin-bottom: 4px;
      }

      .d-nav-name {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.5);
        line-height: 21px;
        text-align: center;
      }
    }

    .danger-nav-item-active {
      .d-nav-name {
        font-weight: 600;
        color: rgba(0, 0, 0, 0.8);
      }
    }

    .danger-nav-item:last-child {
      margin-right: 0px;
    }
  }

  .nav-dot {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 30px;

    .dot-item {
      width: 5px;
      height: 5px;
      border-radius: 50%;
      margin-right: 4px;
      background: #e2e3ea;
    }

    .dot-item-active {
      background: #373d52;
    }

    .dot-item:last-child {
      margin-right: 0px;
    }
  }

  .d-title {
    margin: 0 auto 20px;
    position: relative;
    display: inline-block;
    font-size: 22px;
    font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
    font-weight: 600;
    color: #6759ff;
    line-height: 21px;
  }

  .d-title::before {
    content: '';
    position: absolute;
    right: calc(100% + 16px);
    top: 50%;
    width: 31px;
    height: 1px;
    background-color: #ddd;
  }

  .d-title::after {
    content: '';
    position: absolute;
    left: calc(100% + 16px);
    top: 50%;
    width: 31px;
    height: 1px;
    background-color: #ddd;
  }

  .r-list {
    text-align: left;
    background: rgba(244, 246, 250, 0.9);
    border-radius: 12px;
    padding: 16px;

    .r-item {
      margin-bottom: 20px;

      .r-title {
        position: relative;
        text-indent: 10px;
        font-size: 15px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.8);
        line-height: 21px;
        margin-bottom: 16px;
      }

      .r-title::after {
        content: '';
        left: 0;
        top: 50%;
        transform: translate(0%, -50%);
        position: absolute;
        width: 3px;
        height: 14px;
        background: #9288fd;
      }

      .r-text {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: rgba(0, 0, 0, 0.5);
        line-height: 20px;
      }
    }

    .r-item:last-child {
      margin-bottom: 0;
    }
  }

  .b-tips {
    text-align: left;
    margin-top: 12px;
    font-size: 10px;
    font-family: PingFangSC-Regular, PingFang SC;
    color: rgba(0, 0, 0, 0.5);
    line-height: 20px;
  }
}
</style>
